<form id="service-info-form" *ngIf="validation && show.form" [formGroup]="addEditForm" [ngClass]="{'invalid-submit': invalidSubmit}" (ngSubmit)="saveOrUpdate(dialogBoxService)" RestrictFocus>
  <div class="ui-grid ui-grid-responsive ui-fluid" >

    <div class="ui-g ui-fluid">

      <div class="ui-grid-col-3"><label [ngClass]="{'required': !validation.customerId.nullable}">{{ validation.customerId.keyName }}</label></div>
      <div class="ui-grid-col-3">
        <input type="number" min="0" disabled pInputText class="fieldInput" formControlName="customerId"/>
      </div>

      <div class="ui-grid-col-3"><label [ngClass]="{'required': !validation.serviceId.nullable}">{{ validation.serviceId.keyName }}</label></div>
      <div class="ui-grid-col-3">
        <p-dropdown [disabled]="true" [options]="serviceList" formControlName="serviceId"></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.serviceId"></app-validation-msg>
      </div>

    </div>

    <div class="ui-g ui-fluid">

        <div class="ui-grid-col-3"><label [ngClass]="{'required': !validation.dateStart.nullable}">{{ validation.dateStart.keyName }}</label></div>
        <div class="ui-grid-col-3">
          <app-kv-calendar
          #dateStartField
          [inputName]="'dateStart'"
          [formData]="addEditForm"
          [startDateSelector]="true"
          [endDateInputName]="'dateEnd'"
          [endDateCalendar]="dateEndField"
          [defaultDate]="defaultStartDate"
          [defaultValue]="defaultStartDate"
          >
          </app-kv-calendar>
          <app-validation-msg [arrayValidators]="[validators.checkDateMinorOther_dateEnd]" [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.dateStart"></app-validation-msg>
        </div>

        <div class="ui-grid-col-3"><label [ngClass]="{'required': !validation.dateEnd.nullable}">{{ validation.dateEnd.keyName }}</label></div>
        <div class="ui-grid-col-3">
          <app-kv-calendar
          #dateEndField
          [inputName]="'dateEnd'"
          [formData]="addEditForm"
          [endDateSelector]="true"
          [startDateInputName]="'dateStart'"
          [startDateCalendar]="dateStartField"
          [defaultDate]="defaultEndDate"
          [defaultValue]="defaultEndDate"
          >
          </app-kv-calendar>
          <app-validation-msg [arrayValidators]="[validators.checkDateMajorOther_dateStart]" [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.dateEnd"></app-validation-msg>
        </div>

    </div>

    <div class="ui-g ui-fluid">
        <div class="ui-grid-col-3"><label class="switch-label">{{ fields.flg_state_dis }}</label></div>
        <div class="ui-grid-col-3">
          <p-inputSwitch formControlName="flg_state"></p-inputSwitch>
        </div>
    </div>

    <div class="ui-g ui-fluid">
      <div class="ui-grid-col-3"><label class="switch-label" [ngClass]="{'required': false}">{{ fields.flg_blklst }}</label></div>
      <div class="ui-grid-col-3">
        <p-inputSwitch #blacklist data-testid="blacklist" formControlName="flg_blklst" (onChange)="blacklistChange()"></p-inputSwitch>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.flg_blklst"></app-validation-msg>

      </div>
    </div>

    <div class="ui-g ui-fluid">

      <div class="ui-grid-col-3" [hidden]="!blacklist.checked"><label [ngClass]="{'required': !validation.dateBlklist.nullable}">{{ validation.dateBlklist.keyName }}</label></div>
      <div class="ui-grid-col-2" [hidden]="!blacklist.checked">
        <app-kv-calendar
        [inputName]="'dateBlklist'"
        [formData]="addEditForm"
        [defaultDate]="defaultBlacklistDate"
        [defaultValue]="defaultBlacklistDate"
        >
        </app-kv-calendar>
        <app-validation-msg [arrayValidators]="[validators.checkDateMajorOther_dateStart]" [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.dateBlklist"></app-validation-msg>
      </div>
      <div class="ui-grid-col-1" [hidden]="!blacklist.checked"></div>
      <div class="ui-grid-col-3" [hidden]="!blacklist.checked"><label [ngClass]="{'required': !validation.reasonId.nullable}">{{ validation.reasonId.keyName }}</label></div>
      <div class="ui-grid-col-3" [hidden]="!blacklist.checked">
        <p-dropdown [disabled]="false" [options]="listReasons" formControlName="reasonId"></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.reasonId"></app-validation-msg>
      </div>

    </div>



  </div>

  <p-footer>
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="display: flex; justify-content: center; border: 0; margin-top: 15px;">
      <button class="k-generic-btn" type="submit" pButton icon="fa fa-check" label="{{ 'common.save' | translate }}"></button>
    </div>
  </p-footer>

</form>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/serviceinfo/serviceinfo-form/serviceinfo-form.component.html